<script setup>
import ImgMedia from '@/Components/Images/ImgMedia.vue';
import { Link } from '@inertiajs/vue3';
import { inject } from 'vue';

const dayjs = inject('dayjs');

const props = defineProps({
    type: Object,
    href: String,
    date: String,
});
</script>

<template>
    <Link v-if="href" :href="href" class="w-full cursor-pointer group">
        <div class="relative aspect-[4/3]">
            <div
                class="absolute w-11/12 h-full transition-all duration-500 -translate-x-1/2 -z-10 left-1/2 top-2 bg-secondary group-hover:top-0"
            ></div>

            <ImgMedia
                v-if="type.image"
                :media="type.image"
                classes="absolute inset-0 object-cover w-full h-full"
                :sizes="{ default: '100vw', lg: '400px' }"
            />
        </div>

        <p v-if="type.title" class="mt-4 font-bold text-center md:mt-8 md:text-2xl">{{ type.title }}</p>
        <p v-if="date" class="mt-2 text-center">{{ dayjs(date).format('D MMM, YYYY') }}</p>
    </Link>
</template>
